
export default {
    id: null, // current tour that should be displayed - set by UI when
    params: null,   // specific tour params
    delay: null,
}